import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const sendTelegramMessageDataSchema = z.object({
  botInfo: z.unknown().optional(),
  result: z.unknown().optional(),
  error: z.string().optional(),
});

export type ISendTelegramMessageData = z.infer<typeof sendTelegramMessageDataSchema>;

export const sendTelegramMessageResponseSchema = createApiResponseSchema(
  sendTelegramMessageDataSchema,
) as z.ZodSchema<IAPI<ISendTelegramMessageData>>;

export type ISendTelegramMessageResponse = IAPI<ISendTelegramMessageData>;
